<script>
  import p from 'plotly';
  import { onMount } from 'svelte';
  import { slide } from 'svelte/transition';

  export let backend;
  // add random data to three line traces
  let sumData = [];
  let priceData = [];

  let games = [{
    name: "wow-retail",
    subtypes: [{
      name: "gold",
      descriptors: []
    }]
  }];

  backend.games()
    .then(g => games = g);

  let selectedGame = games[0];
  $: selectedSubtype = selectedGame.subtypes[0];
  let selectedDescriptor = null;

  $: {selectedDescriptor; (async function() {
    if (selectedDescriptor == null) {
      return;
    }
    let dataSegments = await backend.getAvgSoldPriceOfDescriptorByInterval(selectedDescriptor.id);
    if (dataSegments.length == 0) {
      return;
    }
    let start = dataSegments[0].segment;
    let end = dataSegments[dataSegments.length - 1].segment;
    const interval = 60 * 60; // seconds
    let segmentsSize = 1 + (end - start) / interval;
    let xs = [];
    let sumDataMap = new Map();
    let priceDataMap = new Map();
    for (let i = 0; i < segmentsSize; i++) {
      xs[i] = new Date((start + interval * i) * 1000).toLocaleString();
    }
    let lastSegment = start;
    let counter = 0;
    for (let dataSegment of dataSegments) {
      if (lastSegment != dataSegment.segment) {
        lastSegment = dataSegment.segment;
        while (start + counter * interval < dataSegment.segment) {
           counter++;
        }
      }
      let sumProviderData = sumDataMap.get(dataSegment.provider);
      if (sumProviderData == null) {
        sumProviderData = {mode:'lines',line: {shape: 'spline'}, name: dataSegment.provider, x: xs, y: xs.map(x => 0)};
        sumDataMap.set(dataSegment.provider, sumProviderData);
      }
      sumProviderData.y[counter] = dataSegment.quantity;
      let priceProviderData = priceDataMap.get(dataSegment.provider);
      if (priceProviderData == null) {
        priceProviderData = {mode:'lines', name: dataSegment.provider, x: xs, y: xs.map(x => 0)};
        priceDataMap.set(dataSegment.provider, priceProviderData);
      }
      priceProviderData.y[counter] = dataSegment.avgPrice;
    }
    let newSum = [];
    for (const [key, value] of sumDataMap) {
      newSum.push(value);
    }
    sumData = newSum;
    let newPrice = [];
    for (const [key, value] of priceDataMap) {
      newPrice.push(value);
    }
    priceData = newPrice;
  })();};

  $: {priceData;sumData; (function(){
    if (selectedDescriptor != null) {
      let sumPlotDiv = document.getElementById("sumPlot");
      let sumLayout = {
        title: 'Продано валюты',
        uirevision:'true',
        xaxis: {autorange: true},
        yaxis: {autorange: true},

        plot_bgcolor:"#212529",
        paper_bgcolor:"#212529",
        font: {
          color: "white"
        }
      };
      let sumPlot = new p.newPlot(sumPlotDiv, sumData, sumLayout, {showSendToCloud:true});
      let priceLayout = {
        title: 'Средний',
        uirevision:'true',
        xaxis: {autorange: true},
        yaxis: {autorange: true},

        plot_bgcolor:"#212529",
        paper_bgcolor:"#212529",
        font: {
          color: "white"
        }
      };
      let pricePlotDiv = document.getElementById("pricePlot");
      let pricePlot = new p.newPlot(pricePlotDiv, priceData, priceLayout, {showSendToCloud:true});
    }
  }())};
</script>

<main>
<form>
  <select bind:value={selectedGame} class="form-select" aria-label="Выбор игры">
    {#each games as game}
      <option value={game}>
        {game.name}
      </option>
    {/each}
  </select>
  <select bind:value={selectedSubtype} class="form-select" aria-label="Выбор валюты">
    {#each selectedGame.subtypes as subtype}
      <option value={subtype}>
        {subtype.name}
      </option>
    {/each}
  </select>
  <select bind:value={selectedDescriptor} class="form-select" aria-label="Выбор дескриптора">
    {#each selectedSubtype.descriptors as d}
      <option value={d}>
        {d.name}
      </option>
    {/each}
  </select>
  <div id="sumPlot">
  </div>
  <div id="pricePlot">
  </div>

</main>

